// NB: history version should match react-router-dom history dependency version
// Check https://github.com/remix-run/react-router/pull/7586
import { createBrowserHistory, BrowserHistory } from "history";

export type ReadonlyBrowserHistory = Readonly<BrowserHistory>;
const browserHistory: ReadonlyBrowserHistory = createBrowserHistory();

export default browserHistory;
